import type { TypographyOptions } from '@mui/material/styles/createTypography';

import { fontFamily, fontSize, fontWeight, lineHeight, typographyColor } from '../tokens';

export const typographyFigmaThemeConfig: TypographyOptions = {
  fontSize: fontSize.body1,
  fontFamily: `${fontFamily.family}, sans-serif`,
  htmlFontSize: 10,

  body1: {
    fontSize: `${fontSize.body1}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.body1}%`,
    letterSpacing: '0.15px',
  },
  body2: {
    fontSize: `${fontSize.body2}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.body2}%`,
    letterSpacing: '0.17px',
  },
  subtitle1: {
    fontSize: `${fontSize.subtitle1}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.subtitle1}%`,
    letterSpacing: '0.15px',
  },
  subtitle2: {
    fontSize: `${fontSize.subtitle2}px`,
    fontWeight: fontWeight.medium,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.subtitle2}%`,
    letterSpacing: '0.1px',
  },
  overline: {
    fontSize: `${fontSize.overline}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.overline}%`,
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  caption: {
    fontSize: `${fontSize.caption}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.caption}%`,
    letterSpacing: '0.15px',
  },
  h1: {
    fontSize: `${fontSize.h1}px`,
    fontWeight: fontWeight.light,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.h1}%`,
    letterSpacing: '-1.5px',
  },
  h2: {
    fontSize: `${fontSize.h2}px`,
    fontWeight: fontWeight.light,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.h2}%`,
    letterSpacing: '-0.5px',
  },
  h3: {
    fontSize: `${fontSize.h3}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.h3}%`,
  },
  h4: {
    fontSize: `${fontSize.h4}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.h4}%`,
    letterSpacing: '0.25px',
  },
  h5: {
    fontSize: `${fontSize.h5}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.h5}%`,
  },
  h6: {
    fontSize: `${fontSize.h6}px`,
    fontWeight: fontWeight.medium,
    fontStyle: 'normal',
    color: typographyColor.color,
    lineHeight: `${lineHeight.h6}%`,
    letterSpacing: '0.15px',
  },
};
